import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '../../ThemeContext';

import Profile from '../Profile';

import {
  Wrapper,
  Box,
  Titlebox,
  Title,
  Grow,
  Profilebox,
} from './Header.style';

const Header = ({ children, title = '' }) => {
  const theme = useTheme();

  return (
    <Wrapper theme={theme.header.wrapper}>
      <Box>
        <Titlebox>
          <Title theme={theme.header.title}>{title}</Title>
          {children}
        </Titlebox>
        <Grow />
        <Profilebox>
          <Profile />
        </Profilebox>
      </Box>
    </Wrapper>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default Header;
